import { render, staticRenderFns } from "./AddAgreementModal.vue?vue&type=template&id=6f9c20ca&scoped=true&"
import script from "./AddAgreementModal.vue?vue&type=script&lang=ts&"
export * from "./AddAgreementModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddAgreementModal.vue?vue&type=style&index=0&id=6f9c20ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c20ca",
  null
  
)

export default component.exports